module.exports = __webpack_public_path__ + "static/media/tractor.dc7af6e7.jpg";